import React, { useEffect, useState } from "react";
import "./App.css";
import "./main.sass";
import './pages/apps/Solo/chat/solo-chat-overrides.scss'
import { Switch, Route, HashRouter } from "react-router-dom";
// import Home from "./pages1/home/home";
import AuthRoute from "./helpers/authRoute";
import Navigation from "./pages/navigation";
import { SignIn, SignUp } from "./pages/auth";
// import { Auth } from "./pages1/auth";
// import  Home  from "./pages1/home/home";
import { Dashboard } from "./pages/dashboard";
import { CLI } from "./pages/cli";
import Apps from "./pages/apps";
import FormNavigation from "./pages/formNavigation";
import Organization from "./pages/organization";
import { Preview } from "./pages/apps/Assisted/forms/create/Preview";
// import Bpmn from './pages/apps/bpmn/create'
import Profile from './pages/profile'
import Marketplace from './pages/marketplace'
import NotFound from './helpers/commonUi/NotFound';
import { useDispatch, useSelector } from 'react-redux'
import { FLUSH_TOAST } from './stateManager/store/toast/types'
import { setFirebaseConfig } from "./helpers/commonFunction/firebase";
import { loadEnv } from "./helpers/commonFunction";
import { setEnv } from "./constant/common";
import { AppState } from "./stateManager/store";
import ForgotPassword from "./pages/auth/forgotPassword";
import { connectToMQTT } from "./helpers/mqtt";
import Home from "./pages/apps/forms/formBuilder/components/home";
import OnboardingHome from "./pages/apps/forms/formBuilder/components/onboarding/OnboardingHome";
/**
 *
 *  @example ./docs/App.md
 */

declare global {
  interface Window { env: any; }
}
const App: React.FC = () => {
  const user = useSelector((state: AppState) => state.user.data.user)
  // NOTE: this is for handling hyphens in mqtt username
  const mqttUserId = user.id?.replaceAll("-", "")
  const [config, setConfig] = useState(false);

  // Clear any existing toasts on app reload
  const dispatch = useDispatch()
  dispatch({
    type: FLUSH_TOAST
  })

  useEffect(() => {
    const fetchConfig = async () => {
      await setFirebaseConfig();
      const env = await loadEnv();
      window.env = env;
      setConfig(true);
      setEnv();
    }
    fetchConfig();
  }, []);

  useEffect(() => {
    if(mqttUserId) {
      connectToMQTT(mqttUserId)
    }
  }, [mqttUserId])

  return (
    <>
      {config ?
        <HashRouter>
          <Switch>
            <AuthRoute path="/signup" component={SignUp} />
            <AuthRoute path="/signin" component={SignIn} />
            <Route path="/forgotPassword" component={ForgotPassword} />
            {/* <FormNavRoute path="/apps/list/:appId/forms/list/:formId/create" component={FormCreate}></FormNavRoute> */}
            <FormNavRoute path="/apps/list/:appId/forms/list/:formId/preview" component={Preview}></FormNavRoute>
            {/* <Route exact path={"/apps/list/:appId/bpmn/list/:bpmnId/create"} component={Bpmn}></Route> */}
            <Navigation>
              {/* <Route path="/dashboard" component={Dashboard} /> */}
              <Route path={'/home'} component={Home} />
              <Route path={'/select-onboarding'} component={OnboardingHome} />
              <Route path="/apps" component={Apps} />
              <Route path="/organization" component={Organization} />
              <Route path="/profile" component={Profile} />
              <Route path="/marketplace" component={Marketplace} />
              <Route path="/downloads" component={CLI} />
              <Route path="/404" render={props => <NotFound {...props} />} />
              <AuthRoute path="/" />
            </Navigation>
            {/* <Route path="/">
            <AuthRoute />
          </Route> */}
            {/* 
          <AuthRoute path="/signin" component={Auth} />
          <Navigation>
            <AuthRoute path="/" component={Home} />
          </Navigation>
          <Route path="/">
            <AuthRoute />
          </Route> */}
          </Switch>
        </HashRouter> : null}
    </>
  );
};

export const FormNavRoute: React.FC<any> = (props) => {

  return <FormNavigation {...props}>
    <AuthRoute
      exact
      path={props.path}
      component={props.component}
    />
  </FormNavigation>
}

export default App;
